/**
 * The dashboard's usage card (board usage-r1): this week's headline and a line per agent with its tightest limit, and
 * the way into the Usage page. Quiet when usage can't be read (an API or computer that doesn't count yet).
 */
import { AGENT_NAME, dayBars, limitViews, weekHeadline } from '../../domain/usage'
import type { Api } from '../../infra/api'
import { Inline, Link, Skeleton, Stack, Text } from '../../ui'
import { useLoad } from '../useLoad'
import { useNow } from '../useNow'

export function UsageCard({ api }: { api: Api }) {
  const u = useLoad(() => api.usage(), [api])
  const now = useNow(60_000)
  const d = u.data
  return (
    <Stack gap="md">
      {d ? (
        <Stack gap="sm">
          <Text weight="head">{weekHeadline(d.week)}</Text>
          <Text mono tone="muted" size="sm">{dayBars(d.week.days).map((x) => `${x.day} ${x.bar}`).join('  ')}</Text>
          {(d.me?.agents ?? []).map((a) => {
            const top = limitViews(a, now, d.tz).sort((x, y) => y.percent - x.percent)[0]
            return (
              <Text key={a.agent} size="sm" tone={top?.full ? 'default' : 'muted'}>
                {top ? `${AGENT_NAME[a.agent]} · ${top.name.toLowerCase()} ${top.words}` : `${AGENT_NAME[a.agent]} · no limit reported`}
              </Text>
            )
          })}
        </Stack>
      ) : u.error ? (
        <Text tone="muted">How much you build each week shows here. It didn't load just now.</Text>
      ) : (
        <Stack gap="sm" label="Loading">
          <Skeleton />
          <Skeleton />
        </Stack>
      )}
      <Inline justify="between">
        <Link to="/usage">See your usage</Link>
      </Inline>
    </Stack>
  )
}
